import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { IonicPageModule } from 'ionic-angular';
import { PlazaSelectPlanPage } from './plaza-select-plan';

@NgModule({
  declarations: [
    PlazaSelectPlanPage,
  ],
  imports: [
    IonicPageModule.forChild(PlazaSelectPlanPage),
    TranslateModule.forChild()
  ],
})
export class PlazaSelectPlanPageModule {}



// WEBPACK FOOTER //
// ./src/pages/plaza-select-plan/plaza-select-plan.module.ts